import { Breakpoints } from '@/hooks/useBreakpoint';
import styled, { css } from 'styled-components';

export const Container = styled.div<{ $breakpoint: Breakpoints }>`
  position: fixed;

  display: flex;
  flex-direction: column;
  align-items: center;

  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);

  z-index: 996;
  overflow-y: auto;

  ${({ theme }) => {
    return css`
      border-top-left-radius: ${theme.radius[9]}px;
      border-bottom-right-radius: ${theme.radius[9]}px;
    `;
  }};

  ${({ $breakpoint }) => {
    if ($breakpoint === 'desktop') {
      return css`
        width: 100%;
        height: 100%;
        max-width: 550px;
        max-height: 622px;
      `;
    }
    return css`
      top: 58%;
      width: 100%;
      max-width: 90%;
      min-height: 50%;
    `;
  }}
`;
